import { TAB_HIDE, TAB_SHOW } from '../../../../common/tabs/tabs.constants';
import { IDS } from './pnp-doc.constants';
import { deleteDocument, getDocumentDetails, getDocument,getDocumentHistoryDetails, getDocumentReviewerApproverDetails, getDocumentHistory ,getAccreditationDocument } from './pnp-doc.actions';
import { getDocumentCategories, getDocumentStatuse, getDocumentTypes , getAccreditationSchemes  } from '../pnp-docs.actions';
import { PNP_ACCREDITATION_DETAILS_ID,PNP_HISTORY_DETAILS_ID } from '../pnp-docs.actions.types'

/**
 * @const {object}
 * @memberOf module:policies
 */
export const pnpDocument = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $mdDialog, $rootScope, DocumentManager, Notifier) {
        /**
         * @function $onInit
         */
        this.$onInit = () => {
            this.unsubscribe = $ngRedux.connect(({ policies }) => ({
                pnpDocument: policies.pnpDocument
            }), {
                getDocumentDetails,
                getDocumentReviewerApproverDetails,
                deleteDocument,
                getDocumentCategories,
                getDocument,
                getDocumentHistory,
                getDocumentTypes,
                getDocumentStatuse,
                getAccreditationSchemes,
            })(this);

            this.getDocumentTypes('dms');
            this.getDocumentCategories();
            this.getDocumentStatuse();
        }

        this.onSelect = async ({ item }) => {
            try {
                // Hide tabs first
                $ngRedux.dispatch({
                    type: TAB_HIDE,
                    id: IDS.app_policies_documents_manage,
                    state: [
                        IDS.app_policies_documents_accreditation_manage_listing,
                        IDS.app_policies_documents_manage_history_listing,
                        IDS.app_policies_documents_accreditation_add_details,
                        IDS.app_policies_documents_manage_history_listing,
                        IDS.app_policies_documents_event_actions_manage_listing
                    ]
                });

                // Get document details and reviewer/approver information
                await Promise.all([
                    this.getDocumentReviewerApproverDetails(item.id),
                    this.getDocumentDetails(item.id),
                    this.getDocumentHistory(item.id),
                ]);

                // Show document details tab after fetching data
                $ngRedux.dispatch({
                    type: TAB_SHOW,
                    id: IDS.app_policies_documents_manage,
                    state: [IDS.app_policies_documents_manage_details],
                    stateParams: { id: item.id }
                });

                // Delay showing the history tab to avoid conflicts
                this.timeout = setTimeout(() => {
                    $ngRedux.dispatch({
                        type: TAB_SHOW,
                        id: IDS.app_policies_documents_manage,
                        state: [IDS.app_policies_documents_manage_history_listing],
                        stateParams: { id: item.id }
                    });
                    $ngRedux.dispatch({
                        type: PNP_HISTORY_DETAILS_ID,
                        id:'pnpDocumentHistoryGrid',
                        documentid:item.id,
                    })
                }, 150); // Adjust timeout to prevent conflicts

                // Show accreditation listing after delay
                this.timeout = setTimeout(() => {
                    $ngRedux.dispatch({
                        type: TAB_SHOW,
                        id: IDS.app_policies_documents_manage,
                        state: [IDS.app_policies_documents_accreditation_manage_listing],
                        stateParams: { id: item.id }
                    });
                    $ngRedux.dispatch({
                        type: PNP_ACCREDITATION_DETAILS_ID,
                        id:'pnpDocumentAccreditationGrid',
                        accreditationid:item.id
                    })
                }, 150);

                // Show event actions listing after delay
                this.timeout = setTimeout(() => {
                    $ngRedux.dispatch({
                        type: TAB_SHOW,
                        id: IDS.app_policies_documents_manage,
                        state: [IDS.app_policies_documents_event_actions_manage_listing],
                        stateParams: { id: item.id }
                    });
                }, 150);
            } catch (error) {
                console.error("Error in onSelect:", error);
            }
        };


        this.onRemove = ({ item }) => {
            const confirm = $mdDialog.confirm()
                .title('Archive Document')
                .textContent('Are you sure? The chosen document will be archived.')
                .ariaLabel('Archive document')
                .ok('Confirm')
                .cancel('Cancel');
            this.dialog = $mdDialog.show(confirm).then(() => {
                Notifier.success('Document is archived successfully.');
                this.deleteDocument(item.id);
            }, angular.noop);
        };

        this.onDocumentcategory = (event) => {
            this.getDocument();
        };

        this.onReset = (event) => {
            $rootScope.$broadcast('SELECT_CASCADE_RESET', 'pnpDocumentFilterForm');
        };

        this.$onDestroy = () => {
            this.unsubscribe();
            this.dialog && $mdDialog.hide(this.dialog);
            clearTimeout(this.timeout);
        }
    },
    template: `
        <pnp-document-grid
            on-select="$ctrl.onSelect($event)" 
            on-remove="$ctrl.onRemove($event)"
            on-reset="$ctrl.onReset($event)">
        </pnp-document-grid>
    `
};
